import { MenuItem } from 'primeng/api';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

/**
 * Segmentos de rota do módulo Comissões — fonte única (evita "magic strings" em
 * `*.routes.ts`, menu e `routerLink`). `TIPO` é o parâmetro `:tipo` da URL.
 */
export const COMISSOES_ROUTES = {
    ROOT: 'comissoes',
    DASHBOARD: 'dashboard',
    COMISSOES: 'comissoes',
    ITEM: 'item',
    TIPO: {
        ACOMPANHAMENTO: 'acompanhamento',
        ATIVIDADES: 'atividades'
    },
    RELATORIOS: {
        ROOT: 'relatorios',
        CCT_GRUPOS: 'comissoes-camaras-grupos',
        SINTETICO: 'sintetico',
        ANALITICO: 'analitico',
        ENCERRADOS: 'encerrados',
        COMPOSICAO: 'composicao-comissoes-camaras-grupos',
        FREQUENCIA: 'frequencia',
        MEMBROS_POR_UF: 'membros-por-uf',
        PARTICIPACAO_MEMBRO: 'participacao-membro',
        PRODUCAO_ATAS: 'producao-atas',
        CONFIRMACOES_REUNIAO: 'confirmacoes-reuniao',
        REQUISICAO_MATERIAL_SEMANAL: 'requisicao-material-semanal'
    }
} as const;

/** Tipo de comissão por pessoa, derivado do segmento `:tipo`. */
export type TipoComissaoPessoa = (typeof COMISSOES_ROUTES.TIPO)[keyof typeof COMISSOES_ROUTES.TIPO];

/**
 * Menu lateral do módulo Comissões. Os `routerLink` derivam de `COMISSOES_ROUTES`
 * (sem strings soltas); os itens dependentes de contexto usam o `tipo` corrente.
 */
export function createComissoesMenu(tipo: TipoComissaoPessoa): MenuItem[] {
    const { ROOT, DASHBOARD, COMISSOES, RELATORIOS, TIPO } = COMISSOES_ROUTES;
    return [
        {
            label: 'Home',
            items: [
                {
                    label: 'Dashboard',
                    expanded: true,
                    active: true,
                    items: [
                        { label: 'Dashboard', icon: 'pi pi-fw pi-chart-line', routerLink: ['/', ROOT, DASHBOARD], data: { breadcrumb: 'Dashboard' } },
                        { label: 'Acompanhamento', icon: 'pi pi-fw pi-user', routerLink: ['/', ROOT, TIPO.ACOMPANHAMENTO], data: { breadcrumb: 'Acompanhamento' } },
                        { label: 'Atividades', icon: 'pi pi-fw pi-briefcase', routerLink: ['/', ROOT, TIPO.ATIVIDADES], data: { breadcrumb: 'Atividades' } },
                        { label: 'Comissões', icon: 'pi pi-fw pi-sitemap', routerLink: ['/', ROOT, tipo, COMISSOES], data: { breadcrumb: 'Comissões' }, permission: PERMISSOES.comissoes.cadastro.escopo },
                        { label: 'Agenda', icon: 'pi pi-fw pi-calendar', url: 'https://www.google.com/calendar', target: '_blank' },
                        { label: 'Relatórios', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/', ROOT, RELATORIOS.ROOT], data: { breadcrumb: 'Relatórios' }, permission: PERMISSOES.comissoes.relatorios.escopo }
                    ]
                }
            ]
        }
    ];
}
